import React from 'react';
import ReactDOM from 'react-dom';
import { useSpring, animated } from '@react-spring/web';
import close from "../../../src/Assets/close icon.svg";
const Modal = ({ isOpen, onClose, children }) => {
  // Define the modal animation outside the conditional rendering
  const modalAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0)' : 'translateY(-50px)',
    config: { duration: 300 },
  });

  // If the modal is not open, return null early, no need to render anything
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <animated.div
        className="bg-white p-6 w-[422px] max-w-lg max-h-[90vh] overflow-y-auto rounded-[30px] shadow-lg relative modal-scrollbar"
        style={modalAnimation} // Apply the animation styles to the modal
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-700">Check Status</h2>
        </div>

        <button
          onClick={onClose}
          className="absolute top-4 right-2 text-gray-600 hover:text-gray-900 focus:outline-none"
        >
          <img
            src={close} // Replace with your image path
            alt="Close"
            className="h-16 w-16 object-contain"
          />
        </button>

        {children}
      </animated.div>
    </div>,
    document.body



  );
};

export default Modal;
